var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporateparty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_23367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2213 5C26.301 6.66016 26.9125 8.58102 26.9913 10.5598C27.0701 12.5387 26.6132 14.5021 25.6688 16.2428C24.7244 17.9835 23.3276 19.437 21.6259 20.4499C19.9241 21.4627 17.9804 21.9974 16 21.9974C14.0196 21.9974 12.0759 21.4627 10.3742 20.4499C8.67236 19.437 7.27557 17.9835 6.33121 16.2428C5.38684 14.5021 4.92994 12.5387 5.00871 10.5598C5.08748 8.58102 5.69901 6.66016 6.77875 5H25.2213Z",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22V28",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 28H21",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11H27",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_23367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateparty);
export default __webpack_public_path__ + "static/media/Corporateparty.af6f6851d5e00ce4c645bd188e91a236.svg";
export { ForwardRef as ReactComponent };